export function posModulo(value: number,modulo:number): number {
  return ((value%modulo)+modulo)%modulo
}